import { networkService } from "services/networkService";
import {
  METHOD_VOLUME_MANAGER_LIST,
  METHOD_VOLUME_MANAGER_CREATE,
  METHOD_VOLUME_MANAGER_UPDATE,
  METHOD_VOLUME_MANAGER_DELETE,
  METHOD_VOLUME_MANAGER_DETAIL,
} from "constants/admin/masters/hdlm-rac";
class VolumeManagerService {
  getAll = (data) => {
    return networkService
      .post(METHOD_VOLUME_MANAGER_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_VOLUME_MANAGER_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_VOLUME_MANAGER_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_VOLUME_MANAGER_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_VOLUME_MANAGER_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default VolumeManagerService;
